import { motion } from 'framer-motion';

export const TermsOfServicePage = () => {
  return (
    <div className="min-h-screen">
      <section className="pt-32 pb-20 px-4 bg-gradient-to-br from-primary/5 via-background to-secondary/5">
        <div className="max-w-4xl mx-auto">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <h1 className="text-4xl sm:text-5xl font-bold text-foreground mb-6">Terms of Service</h1>
            <p className="text-lg text-muted-foreground">Last updated: January 2026</p>
          </motion.div>
        </div>
      </section>

      <section className="py-20 px-4 bg-background">
        <div className="max-w-4xl mx-auto space-y-12">
          <div>
            <h2 className="text-2xl font-bold text-foreground mb-4">1. Acceptance of Terms</h2>
            <p className="text-muted-foreground leading-relaxed">
              By accessing and using the services of Trademark Assist, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using our services.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-foreground mb-4">2. Description of Services</h2>
            <p className="text-muted-foreground leading-relaxed">
              Trademark Assist provides trademark registration services, copyright registration, comprehensive trademark searches, company formation, and Amazon Brand Registry assistance in the United Kingdom. We act as intermediaries in filing applications with relevant government agencies.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-foreground mb-4">3. User Obligations</h2>
            <div className="text-muted-foreground leading-relaxed">
              <p className="mb-3">When using our services, you agree to:</p>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li>Provide accurate, current, and complete information</li>
                <li>Maintain the confidentiality of your account credentials</li>
                <li>Notify us immediately of any unauthorized use of your account</li>
                <li>Use our services only for lawful purposes</li>
                <li>Not infringe on the intellectual property rights of others</li>
                <li>Comply with all applicable laws and regulations</li>
              </ul>
            </div>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-foreground mb-4">4. Fees and Payment</h2>
            <div className="text-muted-foreground leading-relaxed">
              <p className="mb-3">Service fees are as quoted on our website or in written agreements. Payment terms include:</p>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li>All fees are payable in British Pounds (GBP)</li>
                <li>Government fees are additional and non-refundable</li>
                <li>Payment is required before application filing unless otherwise agreed</li>
                <li>We reserve the right to modify our fees with notice</li>
              </ul>
            </div>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-foreground mb-4">5. Refund Policy</h2>
            <div className="text-muted-foreground leading-relaxed">
              <p className="mb-3">Our refund policy includes:</p>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li>Service fees may be refundable before application filing</li>
                <li>Government fees are non-refundable once paid</li>
                <li>Money-back guarantee applies to specific packages as stated</li>
                <li>Refund requests must be made in writing</li>
              </ul>
            </div>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-foreground mb-4">6. Service Limitations</h2>
            <div className="text-muted-foreground leading-relaxed">
              <p className="mb-3">Please note:</p>
              <ul className="list-disc list-inside ml-4 space-y-2">
                <li>We cannot guarantee trademark application approval</li>
                <li>Application processing times depend on government agencies</li>
                <li>We are not responsible for decisions made by the UK IPO</li>
                <li>Additional fees may apply for office action responses</li>
              </ul>
            </div>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-foreground mb-4">7. Intellectual Property</h2>
            <p className="text-muted-foreground leading-relaxed">
              All content on our website, including text, graphics, logos, and software, is the property of Trademark Assist and protected by copyright and trademark laws. You may not reproduce, distribute, or create derivative works without our written permission.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-foreground mb-4">8. Confidentiality</h2>
            <p className="text-muted-foreground leading-relaxed">
              We maintain strict confidentiality of all client information. Information shared with us will only be used for providing our services and will not be disclosed to third parties except as required by law or with your consent.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-foreground mb-4">9. Limitation of Liability</h2>
            <p className="text-muted-foreground leading-relaxed">
              To the fullest extent permitted by law, Trademark Assist shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of our services. Our total liability shall not exceed the fees paid by you for the specific service.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-foreground mb-4">10. Indemnification</h2>
            <p className="text-muted-foreground leading-relaxed">
              You agree to indemnify and hold Trademark Assist harmless from any claims, damages, or expenses arising from your use of our services, your violation of these terms, or your infringement of any third-party rights.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-foreground mb-4">11. Termination</h2>
            <p className="text-muted-foreground leading-relaxed">
              We reserve the right to terminate or suspend your access to our services immediately, without prior notice, for conduct that we believe violates these Terms of Service or is harmful to our business or other users.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-foreground mb-4">12. Governing Law</h2>
            <p className="text-muted-foreground leading-relaxed">
              These Terms of Service are governed by and construed in accordance with the laws of England and Wales. Any disputes shall be subject to the exclusive jurisdiction of the courts of England and Wales.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-foreground mb-4">13. Changes to Terms</h2>
            <p className="text-muted-foreground leading-relaxed">
              We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately upon posting to our website. Your continued use of our services after changes constitutes acceptance of the new terms.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-foreground mb-4">14. Contact Information</h2>
            <div className="text-muted-foreground leading-relaxed">
              <p className="mb-3">For questions about these Terms of Service, please contact us:</p>
              <ul className="space-y-2">
                <li>Email: info@trademarkassist.co.uk</li>
                <li>Phone: +44 20 4600 6151</li>
                <li>Address: London, United Kingdom</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsOfServicePage;
